/**
 * The `key` to use to interact with ProseMirror `EditorState` atoms
 * @returns `editor-state::{documentId}/{pageId}`
 */
export function editorStateKeyForDocsRoute(params: { documentId: string; pageId: string }): string {
	const { documentId, pageId } = params;
	return `editor-state::${documentId}/${pageId}`;
}
